export * from './Tab/types';
export * from './ScrollableTabs/types';
export * from './TabsNavButton/types';
export var TabsSkin;
(function (TabsSkin) {
    TabsSkin["fullUnderline"] = "fullUnderline";
    TabsSkin["clear"] = "clear";
    TabsSkin["fitUnderline"] = "fitUnderline";
})(TabsSkin || (TabsSkin = {}));
export var TabsAlignment;
(function (TabsAlignment) {
    TabsAlignment["center"] = "center";
    TabsAlignment["left"] = "left";
    TabsAlignment["right"] = "right";
})(TabsAlignment || (TabsAlignment = {}));
export var TabsVariant;
(function (TabsVariant) {
    TabsVariant["fullWidth"] = "fullWidth";
    TabsVariant["fit"] = "fit";
})(TabsVariant || (TabsVariant = {}));
export var TabsNavButtonOptions;
(function (TabsNavButtonOptions) {
    TabsNavButtonOptions["both"] = "both";
    TabsNavButtonOptions["left"] = "left";
    TabsNavButtonOptions["right"] = "right";
    TabsNavButtonOptions["none"] = "none";
})(TabsNavButtonOptions || (TabsNavButtonOptions = {}));
export var OverflowBehavior;
(function (OverflowBehavior) {
    OverflowBehavior["scroll"] = "scroll";
    OverflowBehavior["wrap"] = "wrap";
})(OverflowBehavior || (OverflowBehavior = {}));
//# sourceMappingURL=types.js.map